(function () {
  var dataElement = document.getElementById('tmg-shorts-popup-data');

  if (!dataElement || dataElement.dataset.tmgShortsReady === 'true') {
    return;
  }

  dataElement.dataset.tmgShortsReady = 'true';

  var DISMISS_COOKIE = 'tmg_shorts_dismissed';
  var DISMISS_DAYS = 30;

  function hasDismissed() {
    return document.cookie.split('; ').indexOf(DISMISS_COOKIE + '=1') !== -1;
  }

  function rememberDismissed() {
    var expires = new Date();
    expires.setTime(expires.getTime() + DISMISS_DAYS * 24 * 60 * 60 * 1000);
    document.cookie = DISMISS_COOKIE + '=1; path=/; expires=' + expires.toUTCString() + '; SameSite=Lax';
  }

  // Desktop only; nothing (CSS, DOM, iframe) loads on mobile or after a dismiss.
  var isMobile = (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) ||
    (window.matchMedia && window.matchMedia('(pointer: coarse)').matches);

  if (isMobile || hasDismissed()) {
    return;
  }

  var data;

  try {
    data = JSON.parse(dataElement.textContent);
  } catch (error) {
    return;
  }

  if (!data.videos || !data.videos.length) {
    return;
  }

  var popup;
  var iframe;
  var timer;
  var stopWords = {
    a: true,
    and: true,
    at: true,
    for: true,
    from: true,
    in: true,
    inch: true,
    industrial: true,
    of: true,
    on: true,
    or: true,
    select: true,
    the: true,
    to: true,
    tmg: true,
    up: true,
    with: true,
    x: true
  };

  function normalize(value) {
    return String(value || '')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/&[a-z]+;/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function words(value) {
    var normalized = normalize(value);

    if (!normalized) {
      return [];
    }

    return normalized.split(/\s+/).filter(function (word) {
      return word.length > 1 && !stopWords[word];
    });
  }

  function modelCodes(value) {
    var tokens = normalize(value).split(/\s+/);
    var codes = [];

    tokens.forEach(function (token, index) {
      if (token === 'tmg' && /\d/.test(tokens[index + 1] || '')) {
        codes.push('tmg' + tokens[index + 1]);
      }

      if (/^[a-z]{1,5}\d{2,}[a-z0-9]*$/.test(token)) {
        codes.push(token);
      }
    });

    return codes;
  }

  function scoreVideo(video, contextText, contextWords, contextCodes) {
    var score = 0;
    var titleWords = words(video.title);
    var titleCodes = modelCodes(video.title);

    titleCodes.forEach(function (code) {
      if (contextCodes[code] || contextText.indexOf(code) !== -1) {
        score += 80;
      }
    });

    titleWords.forEach(function (word) {
      if (contextWords[word]) {
        score += word.length > 3 ? 8 : 3;
      }
    });

    return score;
  }

  function selectVideo() {
    var contextText = normalize([window.location.pathname, window.location.search, document.title, data.pageContext].join(' '));
    var contextWords = {};
    var contextCodes = {};
    var bestVideo = data.videos[0];
    var bestScore = -1;

    words(contextText).forEach(function (word) {
      contextWords[word] = true;
    });

    modelCodes(contextText).forEach(function (code) {
      contextCodes[code] = true;
    });

    data.videos.forEach(function (video) {
      var score = scoreVideo(video, contextText, contextWords, contextCodes);

      if (score > bestScore) {
        bestScore = score;
        bestVideo = video;
      }
    });

    return bestVideo;
  }

  function buildEmbedUrl(videoId) {
    var params = new URLSearchParams({
      autoplay: '1',
      mute: '1',
      playsinline: '1',
      controls: '0',
      cc_load_policy: '0',
      disablekb: '1',
      fs: '0',
      iv_load_policy: '3',
      rel: '0',
      modestbranding: '1',
      enablejsapi: '1',
      origin: window.location.origin
    });

    return 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?' + params.toString();
  }

  function createPopup() {
    popup = document.createElement('div');
    popup.className = 'tmg-shorts-popup';
    popup.setAttribute('data-tmg-shorts-popup', '');
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');

    var screen = document.createElement('div');
    screen.className = 'tmg-shorts-popup__screen';

    iframe = document.createElement('iframe');
    iframe.className = 'tmg-shorts-popup__iframe';
    iframe.setAttribute('data-tmg-shorts-iframe', '');
    iframe.title = data.iframeTitle || '';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.loading = 'lazy';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';

    var closeButton = document.createElement('button');
    closeButton.className = 'tmg-shorts-popup__close';
    closeButton.type = 'button';
    closeButton.setAttribute('data-tmg-shorts-close', '');
    closeButton.setAttribute('aria-label', data.closeLabel || 'Close');

    for (var i = 0; i < 2; i++) {
      var line = document.createElement('span');
      line.className = 'tmg-shorts-popup__close-line';
      line.setAttribute('aria-hidden', 'true');
      closeButton.appendChild(line);
    }

    closeButton.addEventListener('click', closePopup);

    screen.appendChild(iframe);
    screen.appendChild(closeButton);
    popup.appendChild(screen);
    document.body.appendChild(popup);
  }

  function openPopup() {
    var video = selectVideo();

    if (!video || !video.id) {
      return;
    }

    createPopup();

    iframe.src = buildEmbedUrl(video.id);
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');

    window.requestAnimationFrame(function () {
      popup.classList.add('is-visible');
    });
  }

  function closePopup() {
    rememberDismissed();
    window.clearTimeout(timer);

    if (!popup) {
      return;
    }

    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');

    window.setTimeout(function () {
      if (popup && popup.parentNode) {
        popup.parentNode.removeChild(popup);
      }

      popup = null;
      iframe = null;
    }, 200);
  }

  function schedulePopup() {
    if (data.stylesheet) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = data.stylesheet;
      document.head.appendChild(link);
    }

    timer = window.setTimeout(openPopup, Number(data.delay) || 7000);
  }

  if (document.readyState === 'complete') {
    schedulePopup();
  } else {
    window.addEventListener('load', schedulePopup, { once: true });
  }
})();
